import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';

@Component({
  selector: 'app-folder-start',
  templateUrl: './folder-start.component.html',
  styleUrls: ['./folder-start.component.scss']
})
export class FolderStartComponent extends DialogPage implements OnInit {

  // Extra data.
	public folderId: string = "";
	public folderName: string = "";
	public buttonText: string;
	public enableAction: boolean;

  constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Lancer";
		this.enableAction = true;
	}

  ngOnInit(): void {
  }

  public setModalOptions(data:any):void {
		this.folderId = data["id"];
		this.folderName = data["name"];
	}

  public save(): void {
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			"folderid": this.folderId,
			"restart": false,
			"sendMail": true,
		};
		this.put("/api/folder-start", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					var modifiedFolder = {
						endDate: response.ENDDATE,
						endDateVal: response.ENDDATEVAL
					}
					this.modalInstance.dismiss(modifiedFolder);
				}
			},
			(err:any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
